import { pathOr } from 'ramda'
import { createSelector } from 'reselect'
import { paramsKey } from './paramsKey'

const NO_SECTIONS = {}
const NO_STATS = {}

export const selectActions = state => pathOr([], ['actions', 'actions'], state)
export const selectActionsLoading = state => pathOr(false, ['actions', 'actionsLoading'], state)
export const selectActionsMeta = state => pathOr(null, ['actions', 'actionsMeta'], state)
const UNSCOPED_STATS_KEY = paramsKey({})
export const selectStatsByKey = state => pathOr(NO_STATS, ['actions', 'statsByKey'], state)
export const selectActionStatsFor = (state, key) => {
  const byKey = selectStatsByKey(state)
  if (Object.prototype.hasOwnProperty.call(byKey, key)) return byKey[key]
  return pathOr(null, ['actions', 'statsKey'], state) === key ? pathOr(null, ['actions', 'stats'], state) : null
}
export const selectActionStats = state => selectActionStatsFor(state, UNSCOPED_STATS_KEY)
export const selectStatsLoading = state => pathOr(false, ['actions', 'statsLoading'], state)
export const selectActionsError = state => pathOr(null, ['actions', 'actionsError'], state)
export const selectStatsError = state => pathOr(false, ['actions', 'statsError'], state)
export const selectStatsKey = state => pathOr(null, ['actions', 'statsKey'], state)
export const selectActionSections = state => pathOr(NO_SECTIONS, ['actions', 'sections'], state)
export const selectCurrentAction = state => pathOr(null, ['actions', 'currentAction'], state)
export const selectCurrentActionLoading = state => pathOr(false, ['actions', 'currentActionLoading'], state)
export const selectMutationLoading = state => pathOr(false, ['actions', 'mutationLoading'], state)
export const selectRemedialRefreshedVersion = state => pathOr(0, ['actions', 'refreshedVersion'], state)
export const selectLastMutatedAction = state => pathOr(null, ['actions', 'lastMutatedAction'], state)
export const selectMutationError = state => pathOr(null, ['actions', 'mutationError'], state)

const VIEW_COUNT_KEYS = ['mine', 'allOpen', 'overdue', 'dueThisWeek', 'needsDecision', 'taskInProgress', 'awaitingReview', 'resolved', 'dismissed']

const toCount = value => {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
}

export const remedialViewCounts = stats => {
  const views = stats?.views || {}
  const counts = Object.fromEntries(VIEW_COUNT_KEYS.map(key => [key, toCount(views[key])]))
  counts.resolvedLast30Days = toCount(stats?.resolvedLast_30Days ?? stats?.resolvedLast30Days)
  return counts
}

export const severityLiveCounts = stats => {
  const live = stats?.bySeverityLive || {}
  return { critical: toCount(live.critical), high: toCount(live.high), medium: toCount(live.medium), low: toCount(live.low) }
}

const selectLatestStats = state => pathOr(null, ['actions', 'stats'], state)

export const selectRemedialViewCounts = createSelector([selectLatestStats], remedialViewCounts)

export const selectSeverityLiveCounts = createSelector([selectLatestStats], severityLiveCounts)
